export interface PostRequestPayload {
  groupRegistrationId: string;
}

export const getTournamentCancelPartnerInvitationApi = (tournamentId: string) =>
  `/v1/tournaments/${tournamentId}/cancel-partner-invitation`;
